// Zentrale Funktion für alle Texte rund um ein Bild.
// Eine einzige Logik für Slideshow, Übersicht, Prerender, OG-Tags und Admin-Vorschau.

const ART_LABEL = {
  de: { dining: "Restaurantfotografie", hotel: "Hotelfotografie", reise: "Reisefotografie" },
  en: { dining: "restaurant photography", hotel: "hotel photography", reise: "travel photography" },
};

// Sprachlicher Wert mit deutschem Fallback: englischer Wert, sonst deutscher.
export const localVal = (work, field, lang) => {
  const de = (work[field] || "").trim();
  if (lang !== "en") return de;
  const en = (work[`${field}_en`] || "").trim();
  return en || de;
};

// Name des Bildes (was/wo es ist). Fallback: bisheriges title-Feld.
export const nameFor = (work, lang = "de") =>
  localVal(work, "name", lang) || (work.title || "").trim();

// Ort des Bildes. Englisch nur, wenn gepflegt, sonst deutsch (explizit gewünscht).
export const ortFor = (work, lang = "de") => localVal(work, "ort", lang);

// Bildunterschrift: „NAME · Ort“. Ort leer: nur Name. Name gleich Ort: nur einmal.
export const captionFor = (work, lang = "de") => {
  const name = nameFor(work, lang);
  const ort = ortFor(work, lang);
  if (!ort || ort === name) return name;
  if (!name) return ort;
  return `${name} · ${ort}`;
};

// Gattung aus der Kategorie des Bildes.
export const genreFor = (work, lang = "de") =>
  (ART_LABEL[lang === "en" ? "en" : "de"][(work.art || "").toLowerCase()] || "").trim();

// Alt-Text automatisch:
// DE: „{Beschreibung}, {Name} in {Ort}, {Gattung} von Wim Jansen Delgado"
// EN: „{description}, {name} in {place}, {genre} by Wim Jansen Delgado"
// Fehlende Teile entfallen sauber samt Komma bzw. „in".
export const altTextFor = (work, lang = "de") => {
  const en = lang === "en";
  const desc = localVal(work, "description", lang) || (en ? work.alt_en : work.alt_de) || "";
  const name = nameFor(work, lang);
  const ort = ortFor(work, lang);
  const genre = genreFor(work, lang);
  const parts = [];
  if (desc.trim()) parts.push(desc.trim());
  if (name && ort) parts.push(en ? `${name} in ${ort}` : `${name} in ${ort}`);
  else if (name) parts.push(name);
  else if (ort) parts.push(ort);
  if (genre) parts.push(en ? `${genre} by Wim Jansen Delgado` : `${genre} von Wim Jansen Delgado`);
  else parts.push(en ? "photography by Wim Jansen Delgado" : "Fotografie von Wim Jansen Delgado");
  return parts.join(", ");
};

// „So erscheint es" im Admin: Name in Versalien, Ort normal, Trennzeichen „ · ".
export const captionPreview = (work, lang = "de") => {
  const name = nameFor(work, lang);
  const ort = ortFor(work, lang);
  if (!ort || ort === name) return name.toUpperCase();
  if (!name) return ort;
  return `${name.toUpperCase()} · ${ort}`;
};
